import { AuditLogTable, ReviewQueue, StatTiles } from "@nwga/features/admin/ui";
import { Button } from "@nwga/ui/components/button";
import { Separator } from "@nwga/ui/components/separator";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
	component: AdminOverviewPage,
	// Warm both panels before the component renders, so the first paint of the
	// console is data rather than three skeletons.
	loader: ({ context }) =>
		Promise.all([
			context.queryClient.ensureQueryData(
				context.trpc.admin.stats.queryOptions(),
			),
			context.queryClient.ensureQueryData(
				context.trpc.admin.reviewQueue.queryOptions(),
			),
		]),
});

function AdminOverviewPage() {
	return (
		<div className="space-y-8">
			<div>
				<h1 className="font-semibold text-2xl tracking-tight">Overview</h1>
				<p className="mt-1 text-muted-foreground text-sm">
					What needs a decision, and what the board looks like today.
				</p>
			</div>

			<StatTiles />

			<section>
				<div className="flex items-baseline justify-between gap-4">
					<h2 className="font-medium text-lg">Waiting for review</h2>
					<Button asChild variant="ghost" size="sm">
						<Link to="/admin/businesses" search={{ tab: "pending" }}>
							All businesses
						</Link>
					</Button>
				</div>
				<div className="mt-3">
					{/* Capped: the overview answers "is there work", the queue page does the work. */}
					<ReviewQueue limit={5} />
				</div>
			</section>

			<Separator />

			<section>
				<div className="flex items-baseline justify-between gap-4">
					<h2 className="font-medium text-lg">Recent activity</h2>
					<Button asChild variant="ghost" size="sm">
						<Link to="/admin/audit">Full audit log</Link>
					</Button>
				</div>
				<div className="mt-3">
					<AuditLogTable pageSize={8} />
				</div>
			</section>
		</div>
	);
}
